/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Mock_Verified_LabelInputs */

const en_st_mock_verified_label = /** @type {(inputs: St_Mock_Verified_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified tasks`)
};

const id_st_mock_verified_label = /** @type {(inputs: St_Mock_Verified_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task terverifikasi`)
};

/**
* | output |
* | --- |
* | "Verified tasks" |
*
* @param {St_Mock_Verified_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_mock_verified_label = /** @type {((inputs?: St_Mock_Verified_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Mock_Verified_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_mock_verified_label(inputs)
	return en_st_mock_verified_label(inputs)
});